import {
  AccountTreeOutlined,
  BarChartOutlined,
  BusinessOutlined,
  CodeOutlined,
  DashboardOutlined,
  DescriptionOutlined,
  FolderOutlined,
  GroupOutlined,
  HomeOutlined,
  LightbulbOutlined,
  ListAltOutlined,
  MapOutlined,
  MenuBookOutlined,
  PeopleAltOutlined,
  PersonOutline,
  PublicOutlined,
  SupportOutlined,
  VpnKeyOutlined,
} from '@mui/icons-material'

import { ROLES } from '~/utils/role-utils'
import { type User } from '~/utils/types/user'

const MENU_ICONS = {
  homepage: HomeOutlined,
  analytics: BarChartOutlined,
  dashboard: DashboardOutlined,
  allies: PublicOutlined,
  hubs: BusinessOutlined,
  stakeholders: GroupOutlined,
  organizations: BusinessOutlined,
  projects: FolderOutlined,
  surveysList: ListAltOutlined,
  users: PeopleAltOutlined,
  'user-invitation': PeopleAltOutlined,
  families: GroupOutlined,
  map: MapOutlined,
  solutions: LightbulbOutlined,
  interventions: AccountTreeOutlined,
  libraries: MenuBookOutlined,
  support: SupportOutlined,
  superset: DashboardOutlined,
  'api-keys': VpnKeyOutlined,
  'api-docs': DescriptionOutlined,
  developer: CodeOutlined,
} as const

export function getMenuIcon(item: string, userRole?: User['role']) {
  if (item === 'families' && userRole === ROLES.FAMILY) return PersonOutline

  return MENU_ICONS[item as keyof typeof MENU_ICONS] ?? ListAltOutlined
}
